module.exports = __webpack_public_path__ + "img/교토라이브1.635008f3.jpg";